import React from 'react';

function FormOptionCard({
  selected,
  title,
  description,
  badge,
  icon: Icon,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={`flex h-full flex-col gap-2 text-left rounded-xl border p-3 transition-all w-full ${
        selected
          ? 'border-forge-500 bg-forge-50 ring-1 ring-forge-500 shadow-sm'
          : 'border-surface-border bg-white text-content-secondary hover:border-slate-300 hover:bg-slate-50'
      }`}
    >
      <div className="flex items-center gap-2.5">
        {Icon && (
          <div
            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border ${
              selected
                ? 'bg-forge-100 border-forge-200 text-forge-700'
                : 'bg-slate-50 border-surface-border text-content-muted'
            }`}
          >
            <Icon className="h-4 w-4" aria-hidden />
          </div>
        )}
        <span
          className={`min-w-0 flex-1 text-sm font-semibold leading-snug ${
            selected ? 'text-forge-800' : 'text-content-primary'
          }`}
        >
          {title}
        </span>
      </div>

      <div className="min-h-[18px]">
        {badge && (
          <span className="inline-block text-[10px] uppercase tracking-wide font-semibold text-forge-700 bg-forge-100 px-1.5 py-0.5 rounded">
            {badge}
          </span>
        )}
      </div>

      {description && (
        <p className="mt-auto min-h-[2.5rem] text-xs leading-relaxed text-content-muted line-clamp-2">
          {description}
        </p>
      )}
    </button>
  );
}

export default FormOptionCard;
